import React, { Component } from 'react'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import { collapsibleClick } from '@cred/react-analytics/events'
import { Text } from '@cred/react-text'
import Font from '@cred/react-font'
import PropTypes from 'prop-types'
import { fireGtmEvent } from 'utils/gtm'
import Collapse from '@kunukn/react-collapse'
import CtaButton from 'components/cta-button'
import { PartnerLogo } from 'components/partner-logo'
import styles from './styles.scss'
import disclaimers from './disclaimers'

class LenderRate extends Component {
  static propTypes = {
    lender: PropTypes.object,
    ctaUrl: PropTypes.string,
    widgetContext: PropTypes.object,
    trackSnowplowEvent: PropTypes.func,
    shouldDarkenBorder: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = { open: false }
  }

  render() {
    const { lender, ctaUrl, shouldDarkenBorder } = this.props,
      { open } = this.state,
      darkenBorderClass = shouldDarkenBorder ? styles.darkenedBorder : ''

    return (
      <div className={`${styles.panel} ${darkenBorderClass}`}>
        <div className="pure-g">
          <div className="pure-u-1 pure-u-md-6-24">
            <div className={`mt-md-16 mb-md-8 ${styles.logo}`}><PartnerLogo partner={lender.slug} /></div>
            { disclaimers[lender.slug]
              && (
                <div className={`mb-md-16 ${styles.disclaimerWrapper}`}>
                  <span className={`${styles.disclaimer} ${styles.light}`} onClick={this.toggleLendersDisclosuresModal}>Disclaimers <i className={`cred-icon ${open ? 'icon-chevron-up' : 'icon-chevron-down'}`} /></span>
                </div>
              )}
          </div>
          <div className="pure-u-1-2 pure-u-sm-9-24 pure-u-md-7-24">
            <Text className={`mt-md-24 ${styles.light}`} type="body-alt">Fixed APR from</Text>
            <Text type="display" className={styles.values}>{lender.minFixedRate}% - {lender.maxFixedRate}%</Text>
          </div>
          <div className="pure-u-1-2 pure-u-sm-8-24 pure-u-md-6-24">
            { lender.minVariableRate && lender.maxVariableRate
              && (
                <>
                  <Text className={`mt-md-24 ${styles.light}`} type="body-alt">Variable APR from</Text>
                  <Text type="display" className={styles.values}>{lender.minVariableRate}% - {lender.maxVariableRate}%</Text>
                </>
              )}
          </div>
          <div className="pure-u-1 pure-u-sm-7-24 pure-u-md-5-24">
            <div className={styles.cta}>
              <CtaButton small blank className="mt-16 mt-sm-8 mt-md-24 mb-8" href={ctaUrl} onClick={this.onClickCta}>Find My Rate</CtaButton>
              <Text type="small-alt" className={styles.light}>on Credible's website</Text>
            </div>
          </div>
          <div className="pure-u-1">
            <Collapse className={styles.dropdown} isOpen={open}>
              <Font element="div" type="bodySmall" color="lighter" className={`${styles.disclosure} mt-24 mb-16`}>
                {disclaimers[lender.slug]}
              </Font>
            </Collapse>
          </div>
        </div>
      </div>
    )
  }

  toggleLendersDisclosuresModal = () => {
    const { open } = this.state,
      { trackSnowplowEvent } = this.props

    trackSnowplowEvent(collapsibleClick, { text: 'Disclaimers', action: open ? 'collapse' : 'expand' })

    this.setState({ open: !open })
  }

  onClickCta = () => {
    const { lender, widgetContext } = this.props,
      lenderData = { lender: lender.name }

    fireGtmEvent('ctaClick', Object.assign(lenderData, widgetContext))
  }
}

export { LenderRate }

export default withSnowplowContexts(LenderRate)
